import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class RecentlyViewedProductsSection extends HTMLElement {
    connectedCallback() {
        this.#hydrate();
    }

    async #hydrate() {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        const viewedProducts = RecentlyViewed.getProducts();

        if (!viewedProducts.length) {
            this.classList.add('recently-viewed-products--hidden');
            return;
        }

        const url = new URL(Theme.routes.search_url, window.location.origin);
        url.searchParams.set('q', viewedProducts.map((id) => `id:${id}`).join(' OR '));
        url.searchParams.set('resources[type]', 'product');

        try {
            await sectionRenderer.renderSection(sectionId, { cache: false, url });
        } catch (error) {
            console.error('Failed to load recently viewed products section', error);
        }
    }
}

if (!customElements.get('recently-viewed-products-section')) {
    customElements.define('recently-viewed-products-section', RecentlyViewedProductsSection);
}
